import { DateTime } from 'luxon';
import { _tk, _ti } from '@wephone-translation';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { DialogComponentBase } from '@wephone-core-ui';
import { DialogActionButton, Colors, ToastService, localNow } from '@wephone-utils';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'call-campaign-reschedule-modal',
  templateUrl: './call-campaign-reschedule.html',
  styleUrls: ['./call-campaign-reschedule.scss']
})
export class CallCampaignRescheduleModal extends DialogComponentBase implements OnInit {
  dialogTitle = _tk('campaign.item.reschedule_form.label');
  dialogRightActions: DialogActionButton[] = [
    {
      label: _tk('public.ok'),
      action: () => {
        return this.submit();
      },
      visible: () => {
        return true;
      },
      color: Colors.PRIMARY
    }
  ];

  startDateCtrl: FormControl;
  startTimeCtrl: FormControl;

  constructor(
    dialogRef: MatDialogRef<CallCampaignRescheduleModal>,
    @Inject(MAT_DIALOG_DATA) public data: {
      hour_start: string;
      scheduled_dt: string;
    },
    private toast: ToastService,
    dateAdapter: DateAdapter<Date>,
  ) {
    super(dialogRef);
    this.dateAdapter = dateAdapter;
  }

  resolveData(): void {
    const now = localNow();
    const scheduleDt: Date = this.data.scheduled_dt ? new Date(this.data.scheduled_dt) : now.toJSDate();
    const hourStart: string = this.data.hour_start ? this.data.hour_start.substring(0, 5) : now.toFormat('HH:mm');
    this.startDateCtrl = new FormControl(scheduleDt);
    this.startTimeCtrl = new FormControl(hourStart);
  }

  submit(): void {
    const date: DateTime = DateTime.fromJSDate(this.startDateCtrl.value);
    const time: string = this.startTimeCtrl.value;
    const array: number[] = time.split(':').map(x => +x);

    const dateTime = date.set({ hour: array[0], minute: array[1], second: 0, millisecond: 0 });

    if (dateTime < DateTime.local()) {
      this.toast.showError(_ti('campaign.validator.scheduled_dt_should_in_future'));
      return;
    }

    this.dismiss({ dateTime });
  }
}
